module.exports = __webpack_public_path__ + "static/media/SNX-logo.0d30c863.png";